<form [formGroup]="form" class="g-slider-container">
  <div class="g-field-area">
    <label class="g-mandatory" for="activationCodeTextarea">{{ dialogTexts.field }}</label>
    <textarea formControlName="code" id="activationCodeTextarea" class="g-large-field" required></textarea>
    <app-validation-message [messageText]="dialogTexts.required" [validation]="formValidatorsService.isEmpty(form.get('code')!)"></app-validation-message>
  </div>
</form>
